import { defineStore } from "pinia";
import { _GettersTree, _ActionsTree, StoreDefinition } from "pinia";
import { IGpsData } from "@/@types/position/coordinates";

const state = (): IGpsData => ({
  speed: 0,
  latitude: 0,
  longitude: 0,
  course: 0,
});

const getters: _GettersTree<IGpsData> = {
  getSpeed: (state: IGpsData): number => state.speed,
  getLat: (state: IGpsData): number => state.latitude,
  getLon: (state: IGpsData): number => state.longitude,
  getCourse: (state: IGpsData): number => state.course,
};

export const coordinates: StoreDefinition<
  string,
  IGpsData,
  _GettersTree<IGpsData>,
  _ActionsTree
> = defineStore<string, IGpsData>("coordinates", {
  state,
  getters,
  actions: {
    setCoordinates(payload: IGpsData | undefined) {
      if (!payload) return;
      this.speed = payload.speed;
      this.latitude = payload.latitude;
      this.longitude = payload.longitude;
      this.course = payload.course;
    },
  },
});
